import {SaveDto} from "../../api";
import {Modal, Result} from "antd";
import QuoteRevisionDiffTable from "../Table/QuoteRevisionDiffTable";
import React from "react";
import {QuoteRevisionDiff} from "../../api/models";

export interface Conflict {
    preview: QuoteRevisionDiff
    dto: SaveDto
}


const SaveConflictModal = ( props: {
    value: Conflict | undefined
    onOk: (d:SaveDto) => void
    onClose: () => void
}) =>
    <Modal
        open={!!props.value}
        onOk={() => props.onOk?.(props.value!.dto)}
        onCancel={props.onClose}
        width={"fit-content"}
    >
        <Result
            status={"error"}
            title={"Attempting to save an old version."}
            subTitle={"Would you like to keep the following changes?"}
        >
            <QuoteRevisionDiffTable
                diff={props.value?.preview}
                columnTitles={[ `Before`, `After` ]}
                hidePriceChange={true}
            />
        </Result>
    </Modal>



export default SaveConflictModal;
